import CourseEntry from '@/models/CourseEntry';
import AssessmentEntry from '@/models/AssessmentEntry';
import { IWillMyCreditsTransferResponse } from '@/models/services/collegetransfer';
import { IAssessmentProvider } from '@/models/services/collegetransfer/entities';

import examples from '@/store/wmct/samples/courses';

interface IApiCheckIn {
	loading: boolean;
	error: boolean;
	data: IApiCheckInData | null;
}

interface IApiCheckInData {
	authorized: boolean;
	institutionName: string | null;
	providers: IAssessmentProvider[] | null;
	nextStepsText: string | null;
}

export interface WillMyCreditsTransferState {
	api: IApiCheckIn;
	courses: CourseEntry[];
	assessments: AssessmentEntry[];

	equivalencyMapLoading: boolean;
	equivalencyMap: IWillMyCreditsTransferResponse;
	equivalencyMapError: boolean;

	seenEquivalencies: number;
}


const state: WillMyCreditsTransferState = {
	api: {
		loading: false,
		error: false,
		data: null,
	},
	courses: [],
	assessments: [],
	equivalencyMap: {
		Transcript: null,
		TransferMap: null,
	},
	equivalencyMapLoading: false,
	equivalencyMapError: false,
	seenEquivalencies: 0,
};

export default state;
